/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { setDiff, and } from '@ember/object/computed';
import { service } from '@ember/service';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import moment from 'moment';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import { byKeys } from '@linc-technologies/linced-common/utils/arrays';

export default class ClassPlacementsController extends Controller {
  // Query params
  fromYear = moment().year();

  toYear = moment().year() + 1;

  // Services
  @service
  options;

  @service
  strings;

  // Properties
  Scopes = Scopes;

  @computed('model.toGroups.@each.{updateTime,currentLearners}')
  get placedLearnerIds() {
    // currentLearners is a flat array per group, so a single-level flatten suffices here.
    return [
      ...new Set(
        this.model.toGroups
          .map((item) => item.currentLearners)
          .flat()
          .map((learner) => learner.personId),
      ),
    ];
  }

  @tracked
  fromGroups = [];
  @tracked
  toGroups = [];
  @tracked
  processingGroups = [];

  @computed('model.fromGroups')
  get filteredFromGroups() {
    return this.model.fromGroups.filter(function (group) {
      return (
        group.type === GroupType.HOMEROOM ||
        (group.type === GroupType.AUTO &&
          group.params.type === 'preenrolledStudents')
      );
    });
  }

  @setDiff('filteredFromGroups', 'fromGroups')
  remainingFromGroups;

  @setDiff('model.toGroups', 'toGroups')
  remainingToGroups;

  @optionAlias('parents:classPlacements:showClass')
  classPageShownToParents;
  @optionAlias('parents:classPlacements:showNextYear')
  nextYearShownToParents;

  @and('classPageShownToParents', 'nextYearShownToParents')
  nextYearShowing;

  nextYear = moment().year() + 1;

  @action
  selectFromGroup(group) {
    this.fromGroups = [...this.fromGroups, group];
  }

  @action
  removeFromGroup(group) {
    this.fromGroups = this.fromGroups.filter((g) => g !== group);
  }

  @action
  selectToGroup(group) {
    this.toGroups = [...this.toGroups, group];
  }

  @action
  removeToGroup(group) {
    this.toGroups = this.toGroups.filter((g) => g !== group);
  }

  @action
  getUnplacedLearners(group) {
    let placed = this.placedLearnerIds;
    return group.currentLearners
      .filter((member) => {
        return !placed.includes(member.personId);
      })
      .sort(byKeys('person.firstName', 'person.lastName'));
  }

  @action
  onLearnerDropped(sourceGroup, targetGroup) {
    this.processingGroups = [
      ...this.processingGroups,
      sourceGroup,
      targetGroup,
    ];
  }

  @action
  onGroupSaved(sourceGroup, targetGroup) {
    this.processingGroups = this.processingGroups.filter(
      (g) => g !== sourceGroup && g !== targetGroup,
    );
  }

  reset() {
    this.fromGroups = [];
    this.toGroups = [];
    this.processingGroups = [];
  }
}
